<template>
  <div class="flex items-start gap-2">
    <div class="flex size-6 shrink-0 items-center justify-center rounded-full bg-[#00022B]">
      <img alt="Wabunka" class="size-5" height="20" src="@/assets/logo/wabunka/symbol.svg" width="20" />
    </div>
    <div class="flex items-center gap-1 rounded-2xl bg-light-bg-inset px-4 py-3">
      <span class="typing-dot size-2 rounded-full bg-light-fg-muted" />
      <span class="typing-dot size-2 rounded-full bg-light-fg-muted [animation-delay:0.2s]" />
      <span class="typing-dot size-2 rounded-full bg-light-fg-muted [animation-delay:0.4s]" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.typing-dot {
  animation: typing-pulse 1.4s infinite ease-in-out;
}

@keyframes typing-pulse {
  0%,
  80%,
  100% {
    opacity: 0.3;
    transform: scale(0.8);
  }

  40% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
